import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Moment } from 'moment';
import { LazyLoadEvent } from 'primeng/api';
import { ContaTev } from 'src/app/base/domain/conta-tev.model';
import { LancamentoDespesa } from 'src/app/base/domain/lancamento-despesa.model';
import { Posto } from 'src/app/base/domain/posto.model';
import { CategoriaDespesa } from 'src/app/base/domain/enum/categoria-despesa.enum';
import { DESCRICAO_FORMA_PAGAMENTO_DESPESA, FormaPagamentoDespesa } from 'src/app/base/domain/enum/forma-pagamento-despesa.enum';
import {
  DESCRICAO_SITUACAO_LANCAMENTO_DESPESA,
  SituacaoLancamentoDespesa,
} from 'src/app/base/domain/enum/situacao-lancamento-despesa.enum';
import { TipoDespesa } from 'src/app/base/domain/enum/tipo-despesa.enum';

export interface LancamentoDespesaListFilterOptions {
  dataInicial: Date;
  dataFinal: Date;
  tiposDespesa: TipoDespesa[];
  categorias: CategoriaDespesa[];
  formasPagamento: FormaPagamentoDespesa[];
  situacoes: SituacaoLancamentoDespesa[];
  postoSelecionado: Posto;
  contaTevSelecionada: ContaTev;
  valorMinimo: number;
  valorMaximo: number;
  descricao: string;
}

export interface LancamentoDespesaAcaoEvent {
  acao: string;
  lancamento: LancamentoDespesa;
}

@Component({
  selector: 'app-lancamento-despesa-list',
  templateUrl: './lancamento-despesa-list.component.html',
  styleUrls: ['./lancamento-despesa-list.component.css'],
})
export class LancamentoDespesaListComponent implements OnInit {
  @Input() title: string;
  @Input() lancamentos: LancamentoDespesa[];
  @Input() totalRecords: number;
  @Input() rowsNumber: number;
  @Input() loading: boolean;
  @Input() totalizador: number;
  @Input() postos: Posto[] = [];
  @Input() contas: ContaTev[] = [];
  @Input() options: string[];

  @Output() filter = new EventEmitter<LancamentoDespesaListFilterOptions>();
  @Output() loadPage = new EventEmitter<number>();
  @Output() acaoClick = new EventEmitter<LancamentoDespesaAcaoEvent>();
  @Output() novo = new EventEmitter<void>();
  @Output() exportar = new EventEmitter<void>();

  tiposDespesa: TipoDespesa[] = Object.values(TipoDespesa);
  categorias: CategoriaDespesa[] = Object.values(CategoriaDespesa);
  formasPagamento: FormaPagamentoDespesa[] = Object.values(FormaPagamentoDespesa);
  situacoes: SituacaoLancamentoDespesa[] = Object.values(SituacaoLancamentoDespesa);

  filterOptions: LancamentoDespesaListFilterOptions;

  private currentPage = 0;

  constructor() {
    this.onLimparFiltros();
  }

  ngOnInit(): void {}

  load(event: LazyLoadEvent): void {
    const pageNumber = Math.floor(event.first / event.rows);
    this.currentPage = pageNumber;
    this.loadPage.emit(pageNumber);
  }

  onAtualizar(): void {
    this.loadPage.emit(this.currentPage);
  }

  onAcaoClick(acao: string, lancamento: LancamentoDespesa): void {
    this.acaoClick.emit({ acao, lancamento });
  }

  onNovo(): void {
    this.novo.emit();
  }

  onExportar(): void {
    this.exportar.emit();
  }

  onDataInicialChange(event: MatDatepickerInputEvent<Moment>): void {
    this.filterOptions.dataInicial = event.value?.toDate() || null;
  }

  onDataFinalChange(event: MatDatepickerInputEvent<Moment>): void {
    this.filterOptions.dataFinal = event.value?.toDate() || null;
  }

  onLimparFiltros(): void {
    this.filterOptions = {
      dataInicial: null,
      dataFinal: null,
      tiposDespesa: [],
      categorias: [],
      formasPagamento: [],
      situacoes: [],
      postoSelecionado: null,
      contaTevSelecionada: null,
      valorMinimo: null,
      valorMaximo: null,
      descricao: '',
    };
  }

  onAplicarFiltro(): void {
    this.filter.emit(this.filterOptions);
  }

  descricaoFormaPagamento(formaPagamento: FormaPagamentoDespesa): string {
    return DESCRICAO_FORMA_PAGAMENTO_DESPESA[formaPagamento] ?? '---';
  }

  descricaoSituacao(situacao: SituacaoLancamentoDespesa): string {
    return DESCRICAO_SITUACAO_LANCAMENTO_DESPESA[situacao] ?? '---';
  }

  descricaoContaTev(conta: ContaTev): string {
    if (!conta) {
      return '---';
    }
    return `${conta.identificador} - Ag. ${conta.agencia} / C. ${conta.conta}`;
  }

  descricaoPagamento(lancamento: LancamentoDespesa): string {
    if (lancamento.formaPagamento === FormaPagamentoDespesa.BANCO) {
      return `Banco: ${this.descricaoContaTev(lancamento.contaTev)}`;
    }
    return 'Caixa';
  }

  generateMask(value: number): string {
    return (value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
}
